import { useState, useEffect } from "react";

const TIMEOUT_DURATION = 20;

interface CountdownEffectProps {
  timeoutActive: boolean;
  isThinking: boolean;
  onTimeout: () => void;
  onTimeoutComplete: () => void;
}

const CountdownEffect = ({
  timeoutActive,
  isThinking,
  onTimeout,
  onTimeoutComplete,
}: CountdownEffectProps) => {
  const [countdown, setCountdown] = useState<number>(TIMEOUT_DURATION);

  useEffect(() => {
    if (timeoutActive && countdown > 0 && !isThinking) {
      const timer = setTimeout(() => {
        if (countdown > 1) {
          setCountdown((prev) => prev - 1);
        } else {
          setCountdown(0);
          onTimeoutComplete();
          onTimeout();
        }
      }, 1000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [timeoutActive, countdown, isThinking, onTimeout, onTimeoutComplete]);

  return null;
};

export { CountdownEffect };

